module.exports = __webpack_public_path__ + "static/media/void.ae31080c.svg";